import { UserContext } from '@context';
import Home from '@screens/Home';
import LogIn from '@screens/LogIn';
import { getApp } from 'firebase/app';
import { getAuth, User } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { Modal, Pressable, StyleSheet, Text, View } from 'react-native';
import 'react-native-gesture-handler';

export default function MainApp() {
	const [initializing, setInitializing] = useState(true);
	const [currentUser, setCurrentUser] = useState(null);
	const [dismissed, setDismissed] = useState(false);
	const reviewQueueUrl =
		getApp().options.projectId === 'loxclub-d171d'
			? 'https://loxclub-d171d-admin.web.app/review-queue'
			: 'https://loxclubtest-admin.web.app/review-queue';

	// Handle user state changes
	function onAuthStateChanged(user: User) {
		setCurrentUser(user);
		if (initializing) setTimeout(() => setInitializing(false), 100);
	}

	useEffect(() => {
		const subscriber = getAuth(getApp()).onAuthStateChanged(onAuthStateChanged);
		return subscriber; // unsubscribe on unmount
	}, [currentUser]);

	if (initializing) return <View />;
	return (
		<UserContext.Provider value={currentUser}>
			{!currentUser && <LogIn />}
			{currentUser && <Home />}
			{currentUser && !dismissed && (
				<Modal
					animationType="fade"
					transparent
					visible
					accessibilityLabel="Closet app deprecated"
					onRequestClose={() => setDismissed(true)}
				>
					<View style={styles.backdrop}>
						<View style={styles.content}>
							<Text style={styles.message}>
								This site is deprecated. Please use the Review Queue instead.
							</Text>
							<a href={reviewQueueUrl} target="_blank" rel="noopener noreferrer">
								Open Review Queue
							</a>
							<Pressable
								accessibilityRole="button"
								onPress={() => setDismissed(true)}
								style={styles.dismissButton}
							>
								<Text style={styles.dismissText}>Continue using closet</Text>
							</Pressable>
						</View>
					</View>
				</Modal>
			)}
		</UserContext.Provider>
	);
}

const styles = StyleSheet.create({
	backdrop: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'rgba(0, 13, 26, 0.6)',
	},
	content: {
		width: '90%',
		maxWidth: 420,
		padding: 24,
		borderRadius: 12,
		backgroundColor: '#fff',
	},
	message: {
		fontSize: 16,
		color: 'rgb(0, 13, 26)',
	},
	dismissButton: {
		alignItems: 'center',
		marginTop: 24,
		paddingVertical: 14,
		borderRadius: 24,
		backgroundColor: 'rgb(0, 13, 26)',
	},
	dismissText: {
		fontSize: 15,
		color: '#fff',
	},
});
